import { Container, Heading3 } from "shared/components";

import styles from "./Content050.module.scss";
import { Items } from "./Items";

export const Content050 = ({ payload }) => {
  const title = payload?.title ?? "";
  const projects = payload?.links ?? [];

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <Heading3 className={styles.title}>{title}</Heading3>
          <div className={styles.content}></div>
          <Items items={projects} />
        </div>
      </Container>
    </div>
  );
};

export default Content050;
